export const listTableOption = {
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: true,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [{
    label: '分组名称',
    prop: 'groupName',
    overHidden: true,
    align: 'left'
  },{
    label: '排序',
    prop: 'sort',
    align: 'left',
  }]
}
